<template>
    <div
        v-if="updateAvailable"
        class="lc-app-update"
        role="alert"
    >
        <span class="lc-app-update__msg">A new version of LiveCaller is available.</span>
        <button
            class="lc-app-update__btn"
            type="button"
            @click="reload"
        >
            Refresh
        </button>
    </div>
</template>

<script setup>
    import useAppUpdate from './useAppUpdate'

    const { updateAvailable, reload } = useAppUpdate()
</script>

<style lang="scss" scoped>
.lc-app-update {
    // bottom-left, next to the version number at the foot of the sidebar
    position: fixed;
    bottom: 1rem;
    left: 1rem;
    z-index: z(top);
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 16px;
    border-radius: 8px;
    background: #1f2937;
    color: #fff;
    font-size: 14px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);

    &__btn {
        border: none;
        border-radius: 6px;
        padding: 6px 14px;
        background: #fff;
        color: #1f2937;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;

        &:hover {
            background: #e5e7eb;
        }
    }
}
</style>
